import { useReduxState } from 'hooks';
import { Link } from 'components/common';
import { BoxTableCell } from 'components/common/box';
import { Icon } from 'components/common/icons';

import type { PageState } from 'types';

interface Props {
  returnPart: 'header' | 'body';
  user?: PageState['user'];
}

const UsersViewCourse = ({ returnPart, user }: Props) => {
  const { messages, serverConfig, theme } = useReduxState();

  const achievementsVisible = !serverConfig.hideAchievementsFromUI;
  const coursesVisible = !serverConfig.hideCoursesFromUI;
  const pathsVisible = !serverConfig.hidePathsFromUI;

  const cellStyle = {
    color: theme.textColorLight,
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.2
  };

  return returnPart === 'header' ? (
    <>
      {achievementsVisible && (
        <BoxTableCell>{messages.usersCompletedAchievements}</BoxTableCell>
      )}

      {coursesVisible && (
        <BoxTableCell>
          <div data-tooltip={messages.usersCompletedCoursesTooltip}>
            {messages.usersCompletedCourses}
            <Icon
              icon="question-circle"
              style={{
                fontSize: '1.1rem',
                marginLeft: 5,
                position: 'relative',
                top: -1
              }}
            />
          </div>
        </BoxTableCell>
      )}

      {pathsVisible && (
        <BoxTableCell>{messages.usersCompletedPaths}</BoxTableCell>
      )}
    </>
  ) : returnPart === 'body' && user ? (
    <>
      {achievementsVisible && (
        <BoxTableCell>
          {user?.completedData?.achievements ? (
            <Link
              as={`/users/${user.id}/achievements`}
              href="/users/[userId]/achievements"
              text={user?.completedData?.achievements}
              style={cellStyle}
            />
          ) : null}
        </BoxTableCell>
      )}

      {coursesVisible && (
        <BoxTableCell>
          {user?.completedData?.courses ? (
            <Link
              as={`/users/${user.id}/courses`}
              href="/users/[userId]/courses"
              text={user?.completedData?.courses}
              style={cellStyle}
            />
          ) : null}
        </BoxTableCell>
      )}

      {pathsVisible && (
        <BoxTableCell>
          {user?.completedData?.paths ? (
            <Link
              as={`/users/${user.id}/paths`}
              href="/users/[userId]/paths"
              text={user?.completedData?.paths}
              style={cellStyle}
            />
          ) : null}
        </BoxTableCell>
      )}
    </>
  ) : null;
};

export default UsersViewCourse;
